import { RoomPropertyEnum } from "../../constants/NavbarList";
import { DashboardTour, TaxExempt } from "./TourDetails";
import "./TutorialComponent.css";
import { Box } from "@mui/material";

interface TutorialComponentProps {
  page: RoomPropertyEnum;
}

export const TutorialComponent: React.FC<TutorialComponentProps> = ({
  page,
}) => {
  const getTutorialDetails = () => {
    switch (page) {
      case RoomPropertyEnum.propertyInformation:
        return DashboardTour();
      case RoomPropertyEnum.taxExemptCategory:
        return TaxExempt();
      case RoomPropertyEnum.buildingCodes:
        return;
      case RoomPropertyEnum.roomFeatures:
        return;
      case RoomPropertyEnum.roomLocation:
        return;
      case RoomPropertyEnum.HousekeepingSections:
        return;
      case RoomPropertyEnum.roomTypeMaintainence:
        return;
      case RoomPropertyEnum.roomDefinitions:
        return;
      case RoomPropertyEnum.department:
        return;
      case RoomPropertyEnum.category:
        return;
      case RoomPropertyEnum.taxes:
        return;
      case RoomPropertyEnum.origin:
        return;
      case RoomPropertyEnum.guestType:
        return;
      case RoomPropertyEnum.postTypes:
        return;
      case RoomPropertyEnum.Transportation:
        return;
      case RoomPropertyEnum.PaymentMethods:
        return;
      case RoomPropertyEnum.Segment1:
        return;
      case RoomPropertyEnum.Segment2:
        return;
      default:
        return;
    }
  };

  return <Box>{getTutorialDetails()}</Box>;
};
